module.exports = __webpack_public_path__ + "img/27.2564507c.png";